import { createContext } from 'react';
import { HomeContextState } from './HomeContextState';
export const HomeContext = createContext<HomeContextState>(new HomeContextState());